import React from "react";
import { createRoot } from "react-dom/client"; // New API for React 18
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container); // Create a root with React 18's API

root.render(
  <App /> // App contains your <Router> component
);
